// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mediaItem[data-v-5e15171e] {\r\n    display: inline-block;\n}\n.imgbtn i[data-v-5e15171e] {\r\n    position: absolute;\r\n    right: -5px;\r\n    top: -4px;\r\n    width: 20px;\r\n    height: 20px;\r\n    color: white;\r\n    background: red;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n    line-height: 20px;\r\n    font-weight: bold;\n}\n.imgbtn[data-v-5e15171e] {\r\n    position: relative;\n}\r\n", ""]);
// Exports
module.exports = exports;
